import { BusinessTrip } from "@models";
import React from "react";

type ReviewContextValue = {
	onChanged: (trip: BusinessTrip) => void;
	refreshTrip: (trip: BusinessTrip) => void;
};

export default React.createContext<ReviewContextValue | null>(null);
